import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  && {\n    background-color: ", ";\n    color: #fff;\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: ", ";\n    padding: 10px 12px;\n    width: auto;\n    white-space: nowrap;\n    box-shadow: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// @ts-nocheck
import React from 'react';
import { Popover } from 'reakit';
import styled from '../utils/styling/styled-components';
// @ts-ignore
// Typing this as any for now until I have time to find a fix.
var StyledTooltip = styled(Popover)(_templateObject(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.borderRadius.small;
}, function (props) {
  return props.theme.shadows.lgMedium;
});

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      position = _ref.position,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    placement: position,
    visible: visible,
    className: className
  }, children);
};

export { Tooltip };